// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-module--container--1hHzs","bg":"modal-module--bg--tfRaa","fadeIn":"modal-module--fadeIn--gFQgn"};